export default __webpack_public_path__ + "static/media/Chalenge_description.24166179.pdf";